import axiosInstance from "@/axios";

const axios = axiosInstance();

export const state = {
    currentUser: JSON.parse(localStorage.getItem("user")) || null,
    authError: null,
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('user', newValue)
        localStorage.setItem("user", JSON.stringify(newValue));
    },
    SET_AUTH_MSG(state, authError) {
        state.authError = authError
    },
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser
    },
    authError: state => state.authError,
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    async logIn({ commit }, { email, password } = {}) {
        try {
            const result = await axios.post("/agent/login", {
                email,
                password,
            });

            commit('SET_CURRENT_USER', result.data.user);
            localStorage.setItem('token', result.data.token);
            commit("SET_AUTH_MSG", null);
        } catch (error) {
            commit("SET_AUTH_MSG", error.response.data.message);
            throw error;
        }
    },


    async logOut({ commit }) {
        try {
            // Try to call logout endpoint if token exists
            const token = localStorage.getItem('token');
            if (token) {
                await axiosInstance({ requiresAuth: true }).post("/agent/logout");
            }
        } catch (error) {
            // If logout fails, we still want to clear local data
            // Silently continue with cleanup
        } finally {
            // Always clear local authentication data
            commit('SET_CURRENT_USER', null);
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            sessionStorage.clear();
        }
    },

    // Force logout without API call (for when token is already invalid)
    forceLogOut({ commit }) {
        commit('SET_CURRENT_USER', null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        sessionStorage.clear();
    },

    register({ commit, dispatch, getters }, { username, email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return axiosInstance.registerUser(username, email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },

    resetPassword({ dispatch, getters }, { email } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return axiosInstance.forgetPassword(email).then((response) => {
            const message = response.data
            return message
        });
    },

    validate({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null)
        const user = axiosInstance.getAuthenticatedUser();
        commit('SET_CURRENT_USER', user)
        return user;
    },
}


function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
